/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-unused-vars */
import React from "react";

// eslint-disable-next-line react/prop-types
function GroupIcon({ width = 89, height = 103, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="89"
      height="103"
      viewBox="0 0 89 103"
      fill="none"
      {...props}
    >
      <circle
        cx="76.12"
        cy="24.1298"
        r="12.558"
        fill="url(#paint0_linear_740_4752)"
      />
      <path
        d="M49.7162 58.9059C41.9884 33.1458 58.8396 6.41977 67.1043 0.301758C49.0724 35.0778 60.3421 47.3138 65.8161 45.0598C71.2901 42.8058 83.2041 38.9418 89.0001 42.8058C89.0001 42.8058 79.3403 42.8058 71.6121 58.9059C67.947 69.6312 74.953 86.3183 79.3403 93.0379C70.6461 90.1399 57.444 84.6659 49.7162 58.9059Z"
        fill="url(#paint1_linear_740_4752)"
      />
      <path
        d="M25.5662 34.4337C25.5662 41.3694 19.9438 46.9918 13.0082 46.9918C6.07261 46.9918 0.450195 41.3694 0.450195 34.4337C0.450195 28.7281 4.25525 23.9112 9.46621 22.3822C10.5896 22.0526 10.1878 16.224 15.9062 17.3677C19.1262 18.0118 19.7702 19.5183 19.7702 21.2318C19.7702 22.8418 19.2677 23.5269 19.7702 23.8078C23.6124 25.9553 25.5662 29.7194 25.5662 34.4337Z"
        fill="url(#paint2_linear_740_4752)"
      />
      <path
        d="M40.0108 68.566C47.7387 42.806 30.8875 16.0799 22.6228 9.96191C40.6547 44.738 29.385 56.974 23.911 54.72C18.437 52.466 6.52294 48.602 0.726948 52.466C0.726948 52.466 10.3868 52.466 18.115 68.566C21.7801 79.2914 14.774 95.9784 10.3868 102.698C19.081 99.8001 32.283 94.3261 40.0108 68.566Z"
        fill="url(#paint3_linear_740_4752)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_740_4752"
          x1="84.954"
          y1="12.1822"
          x2="81.1548"
          y2="45.2358"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#64C7FF" />
          <stop offset="1" stopColor="#1F5DFD" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_740_4752"
          x1="82.8821"
          y1="2.55576"
          x2="52.9361"
          y2="118.476"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#64C7FF" />
          <stop offset="1" stopColor="#1F5DFD" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_740_4752"
          x1="4.53885"
          y1="18.6665"
          x2="6.64872"
          y2="49.9331"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FAA3D7" />
          <stop offset="1" stopColor="#CF1083" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_740_4752"
          x1="35.2713"
          y1="14.4699"
          x2="22.9559"
          y2="110.727"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FAA3D7" />
          <stop offset="1" stopColor="#CF1083" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default GroupIcon;
